import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../lib/const/constants';
import getCurrencySymbol from '../../lib/currenyUtils';
import { MdOutlineCurrencyExchange } from 'react-icons/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import 'react-tabs/style/react-tabs.css';
import ChangeStatusDialog from './Component/ChangeStatusDialog';
import PropTypes from 'prop-types';
import {
  FiArrowDownLeft,
  FiArrowUpRight,
  FiFilter,
  FiEye,
  FiSearch,
  FiChevronLeft,
  FiChevronRight,
  FiX,
} from 'react-icons/fi';
import { encryptPayload } from '../../utils/encryption';

function DebitTransactions({ fromHome }) {
  DebitTransactions.propTypes = {
    fromHome: PropTypes.bool,
  };
  const location = useLocation();
  const paramsdata = location.state || {};
  console.log('paramsdata', paramsdata);
  const userFileInputRef = useRef(null);
  const complianceFileInputRef = useRef(null);
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [editingDocIndex, setEditingDocIndex] = useState(null);
  const handleClose = () => {
    setShow(false);
    setLoading(false);
    setEdit(false);
    setPaymentStatus();
    setEditingDocIndex(null);
    setPaymentId();
    setPaymentSubmitted();
    setpayoutButton('Submit to payout');
    setDeletedUserAttachments([]);
    setDeletedComplianceAttachments([]);
    setTransferfee('');
    setServicefee('');
  };
  const handleShow = () => {
    setShow(true);
  };

  const [amount, setAmount] = useState('');
  const [currencysymbol, setCurrencysymbol] = useState();
  console.log('Amount', amount);
  const [date, setDate] = useState('');
  const [beneName, setBeneName] = useState('');
  const [receiverName, setReceiverName] = useState('');
  const [refId, setRefId] = useState('');
  const [beneBankNumber, setBeneBankNumber] = useState('');
  const [beneBankCodeValue, setBeneBankCodeValue] = useState('');
  const [cardFees, setcardFees] = useState('');
  const [, setpaymentMethod] = useState('');
  const [uploadedDocuments, setuploadedDocuments] = useState([]);
  // const [, setUploadedDocuments] = useState([]);
  // const [fieldName, setFieldName] = useState('');
  // const [fieldValue, setFieldValue] = useState('');
  // const [flag, setFlag] = useState('');
  const [, setUserNotes] = useState('');
  const [userAttachment, setuserAttachment] = useState([]);
  const [complianceNotes, setComplianceNotes] = useState('');
  const [complianceAttachment, setcomplianceAttachment] = useState([]);
  // const [edituserNotes, seteditUserNotes] = useState('');
  const [editcomplianceNotes, seteditComplianceNotes] = useState('');
  const [pendingComplianceFiles, setPendingComplianceFiles] = useState([]);
  const [adminRequestedAttachments, setadminRequestedAttachments] = useState(
    [],
  );
  const [edit, setEdit] = useState(false);
  const [deletedUserAttachments, setDeletedUserAttachments] = useState([]);
  const [deletedComplianceAttachments, setDeletedComplianceAttachments] =
    useState([]);
  // const [changestatusdropdown, setChangestatusdropdown] = useState(false);

  const [editfieldName, seteditFieldName] = useState([]);
  const [editfieldValue, seteditFieldValue] = useState([]);
  const [editflag, seteditFlag] = useState();
  // const [edituserNotes,setedituserNotes] = useState();
  const [edituserAttachment, setedituserAttachment] = useState([]);
  const [edittypeOfDocuments, setedittypeOfDocuments] = useState([]);

  const [editfieldSelectedName, seteditFieldSelectedName] = useState();
  const [editfieldSelectedValue, seteditFieldSelectedValue] = useState();
  const [editSelectedflag, seteditSelectedFlag] = useState();
  const [, setSave] = useState(false);
  const [beneId, setBeneId] = useState('');
  const [individual, setIndividual] = useState([]);
  const [business, setBusiness] = useState([]);
  const [transactionUserType, setTransactionUserType] = useState();
  const [paymentStatus, setPaymentStatus] = useState();
  const [paymentId, setPaymentId] = useState();
  const [paymentSubmitted, setPaymentSubmitted] = useState();
  const [payoutButton, setpayoutButton] = useState('Submit to payout');
  // const [ip, setIP] = useState();
  // const [email, setEmail] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const beneficiary_id = queryParams.get('beneficiary_id');
  const [changeStatusTransactionId, setChangeStatusTransactionId] = useState();
  const [changeStatusWorkspaceId, setChangeStatusWorkspaceId] = useState();
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [showUploadRow, setShowUploadRow] = useState(null);
  const [documents] = useState({});
  const [sellamount, setSellAmount] = useState('');
  const [sellcurrency, setSellcurrency] = useState('');
  const [uploading, setUploading] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [, setDocumentNotes] = useState([]);
  // const [isprocessing, setIsProcessing] = useState(false);
  const [searchText, setSearchText] = useState({
    transactionId: '',
    date: '',
    sender: '',
    receiver: '',
    sendingAmount: '',
    receivingAmount: '',
    status: '',
  });

  const [combinedSearch, setCombinedSearch] = useState('');
  const debounceRef = useRef(null);
  const txnIdDebounceRef = useRef(null);
  const receiverDebounceRef = useRef(null);

  const [transactionType, setTransactionType] = useState('');
  const [createdat, setCreatedat] = useState(null);
  const [updatedat, setUpdatedat] = useState(null);
  const [transactionStatus, setTransactionStatus] = useState('');
  const [transferReason, setTransferReason] = useState('');
  const [currency, setCurrency] = useState('');
  const [senderNameDrawer, setSenderNameDrawer] = useState('');
  const [beneficiaryNameDrawer, setBeneficiaryNameDrawer] = useState('');
  const [shownotes, setShownotes] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const filterRef = useRef(null);
  const [uiPage, setUiPage] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const noResultsFound = !loading && !pageLoading && transactions.length === 0;
  const [transferfee, setTransferfee] = useState('');
  const [servicefee, setServicefee] = useState('');

  const ITEMS_PER_PAGE = 10;

  const totalPages = fromHome
    ? 1
    : !hasMore
      ? Math.ceil(transactions.length / ITEMS_PER_PAGE)
      : Math.ceil(transactions.length / ITEMS_PER_PAGE) + 1;

  const currentPageComplete =
    transactions.length >= uiPage * ITEMS_PER_PAGE || !hasMore;

  const handleLocalNoteChange = (index, value, isNew = false) => {
    if (isNew) {
      setedituserAttachment((prev) =>
        prev.map((doc, i) => (i === index ? { ...doc, note: value } : doc)),
      );
    } else {
      setuploadedDocuments((prev) =>
        prev.map((doc, i) => (i === index ? { ...doc, note: value } : doc)),
      );
    }
  };

  const handleDeleteDoc = (index) => {
    setuploadedDocuments((prev) => prev.filter((_, i) => i !== index));
  };

  const PageSpinner = ({ message }) => (
    <div className="flex flex-col items-center justify-center py-20 gap-4">
      <div
        className="w-10 h-10 rounded-full border-4 border-gray-200"
        style={{
          borderTopColor: '#0B214E',
          animation: 'spin 0.75s linear infinite',
        }}
      />
      <p className="text-sm text-gray-400 font-medium">{message}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  PageSpinner.propTypes = { message: PropTypes.string };
  PageSpinner.defaultProps = { message: 'Loading transactions…' };

  var two_fa = sessionStorage.getItem('two_fa');
  var qr_enabled = sessionStorage.getItem('qr_enabled');
  var qr_login_completed = sessionStorage.getItem('qr_login_completed');

  console.log('edit value:', edit);
  console.log('sendamount', amount);
  console.log('code', beneBankCodeValue);

  
  useEffect(() => {
    const staffLoggedIn = !!sessionStorage.getItem('staff_login_token');
    const twoFaCompleted =
      qr_enabled == 1 &&
      (qr_login_completed == 1 || paramsdata.qr_login_completed == 1);
    if (!staffLoggedIn || (two_fa == 1 && !twoFaCompleted)) {
      navigate('/stafflogin');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDocumentNotes(uploadedDocuments.map(() => ''));
  }, [uploadedDocuments]);

  useEffect(() => {
    const handler = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target))
        setShowFilterDropdown(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const CURRENCY_SYMBOLS = {
    INR: '₹',
    GBP: '£',
    EUR: '€',
    USD: '$',
    AED: 'د.إ',
    CAD: '$',
    AUD: '$',
    SGD: '$',
    HKD: '$',
    JPY: '¥',
    CNY: '¥',
    CHF: '₣',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    ZAR: 'R',
    MXN: '$',
    BRL: 'R$',
    TRY: '₺',
    RUB: '₽',
    KWD: 'د.ك',
    SAR: '﷼',
    QAR: '﷼',
    BHD: '.د.ب',
    OMR: '﷼',
    NZD: '$',
    THB: '฿',
    MYR: 'RM',
    IDR: 'Rp',
    PHP: '₱',
    VND: '₫',
    PKR: '₨',
    LKR: '₨',
    BDT: '৳',
    NGN: '₦',
    KES: 'KSh',
    GHS: '₵',
    UGX: 'USh',
    TZS: 'TSh',
    ETB: 'Br',
    XOF: 'CFA',
    XAF: 'CFA',
    MAD: 'د.م.',
    EGP: 'E£',
    DZD: 'دج',
    TND: 'د.ت',
    ILS: '₪',
    JOD: 'JD',
    LBP: 'ل.ل',
    UAH: '₴',
    PLN: 'zł',
    CZK: 'Kč',
    HUF: 'Ft',
    RON: 'lei',
    BGN: 'лв',
    HRK: 'kn',
    RSD: 'дин',
    ISK: 'kr',
    CLP: '$',
    COP: '$',
    PEN: 'S/',
    ARS: '$',
    UYU: '$U',
    BOB: 'Bs.',
  };

  const handlePageChange = async (page) => {
    if (page < 1 || pageLoading) return;
    if (page > uiPage && uiPage >= totalPages && !hasMore) return;
    const requiredItems = page * ITEMS_PER_PAGE;
    if (requiredItems > transactions.length) {
      if (!hasMore) return;
      setPageLoading(true);
      await getData(currentPage);
      setPageLoading(false);
    }
    setUiPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getStatusStyle = (s) => {
    const st = (s || '').toLowerCase();
    if (st === 'settled')
      return {
        bg: 'bg-emerald-50',
        color: 'text-emerald-700',
        label: 'Settled',
      };
    if (st === 'completed')
      return {
        bg: 'bg-emerald-50',
        color: 'text-emerald-700',
        label: 'Completed',
      };
    if (st === 'processing')
      return { bg: 'bg-blue-50', color: 'text-blue-700', label: 'Processing' };
    if (st === 'pending')
      return { bg: 'bg-red-50', color: 'text-red-700', label: 'Pending' };
    if (st === 'review')
      return { bg: 'bg-amber-50', color: 'text-amber-700', label: 'Review' };
    if (st === 'waiting for funds' || st === 'waiting for fund')
      return {
        bg: 'bg-red-50',
        color: 'text-red-700',
        label: 'Waiting for funds',
      };
    return { bg: 'bg-gray-100', color: 'text-gray-700', label: s };
  };
  const uploadDocument = async (
    transaction_id,
    document_id,
    document,
    filename,
    counter,
  ) => {
    var extension = filename.split('.');
    const token = sessionStorage.getItem('login_token');
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-194-UPLOAD-TRANSACTION-DOCUMENTS',
        {
          transaction_id: transaction_id,
          document_id: document_id,
          document: document,
          extension: extension[extension.length - 1],
        },
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        console.log('uploaded' + resp);
        if (counter == documents[transaction_id].length) {
          toast.success('Uploaded Successfully.');
          setUploading(false);
          location.reload();
        }
      })
      .catch((err) => {
        toast.error('Something went wrong.Please try again later.');
        console.log('error' + err);
      });
  };
  const handleUpload = (transaction_id) => {
    var counter = 1;
    const filesForTxn = selectedFiles[transaction_id] || {};

    if (Object.keys(filesForTxn).length === 0) {
      toast.error('Please select at least one file');
      return;
    }

    const docsForTxn = documents[transaction_id] || [];

    docsForTxn.forEach((doc) => {
      const file = filesForTxn[doc.document];
      if (!file) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setUploading(true);
        uploadDocument(
          transaction_id,
          doc.document_id,
          reader.result,
          file.name,
          counter,
        );
        counter++;
      };
      reader.readAsDataURL(file);
    });
  };
  const handleFileChange = (event, docName, txnId) => {
    const file = event.target.files[0];
    setSelectedFiles((prev) => ({
      ...prev,
      [txnId]: {
        ...prev[txnId],
        [docName]: file,
      },
    }));
  };
  const getIconBg = (type, status) => {
    if (type !== 'debit') {
      return type == null || type === '' || type === 'individual'
        ? 'bg-orange-50 text-orange-500'
        : 'bg-blue-50 text-blue-500';
    }
    const st = (status || '').toLowerCase();
    if (st === 'settled' || st === 'completed')
      return 'bg-emerald-50 text-emerald-600';
    if (st === 'processing') return 'bg-blue-50 text-blue-600';
    if (st === 'pending' || st === 'review') return 'bg-red-50 text-red-600';
    if (st === 'waiting for funds') return 'bg-red-50 text-red-600';
    return 'bg-emerald-50 text-emerald-600';
  };

  const renderIcon = (beneficiary) => {
    const st = (beneficiary.status || '').toLowerCase();
    if (beneficiary.type !== 'debit') {
      return beneficiary.type == null ||
        beneficiary.type === '' ||
        beneficiary.type === 'individual' ? (
        <MdOutlineCurrencyExchange size={17} />
      ) : (
        <FiArrowDownLeft size={17} />
      );
    }
    if (st === 'settled' || st === 'completed')
      return <FiArrowUpRight size={17} />;
    if (st === 'processing')
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
    if (st === 'pending' || st === 'review')
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      );
    if (st === 'waiting for funds')
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 3h14" />
          <path d="M5 21h14" />
          <path d="M5 3a7 7 0 0 1 7 7" />
          <path d="M19 3a7 7 0 0 1-7 7" />
          <path d="M5 21a7 7 0 0 0 7-7" />
          <path d="M19 21a7 7 0 0 0-7-7" />
        </svg>
      );
    return <FiArrowUpRight size={17} />;
  };

  const STATUS_OPTIONS = [
    { label: 'Settled', value: 'settled' },
    { label: 'Completed', value: 'completed' },
    { label: 'Processing', value: 'processing' },
    { label: 'Pending', value: 'pending' },
    { label: 'Review', value: 'review' },
    { label: 'Waiting for funds', value: 'waiting for funds' },
  ];

  const getData = async (pagenumber, searchParams = searchText) => {
    const login_id = sessionStorage.getItem('login_id');
    const login_token = sessionStorage.getItem('staff_login_token');
    // const login_email = sessionStorage.getItem('login_email');
    // setEmail(login_email);
    if (!login_id || !login_token) {
      sessionStorage.clear();
      navigate('/business');
      return;
    }
    setLoading(true);
    var dataUrl =
      Constants.BASE_URL +
      'API-FX-198-STAFF-TRANSACTIONS?page=' +
      pagenumber +
      '&transactionId=' +
      searchParams.transactionId +
      '&date=' +
      searchParams.date +
      '&sender=' +
      searchParams.sender +
      '&receiver=' +
      searchParams.receiver +
      '&sendingAmount=' +
      searchParams.sendingAmount +
      '&receivingAmount=' +
      searchParams.receivingAmount +
      '&status=' +
      searchParams.status;
    if (beneficiary_id != '' && beneficiary_id != null)
      dataUrl =
        Constants.BASE_URL +
        'API-FX-198-STAFF-TRANSACTIONS?page=' +
        pagenumber +
        '&beneficiary_id=' +
        beneficiary_id +
        '&transactionId=' +
        searchParams.transactionId +
        '&date=' +
        searchParams.date +
        '&sender=' +
        searchParams.sender +
        '&receiver=' +
        searchParams.receiver +
        '&sendingAmount=' +
        searchParams.sendingAmount +
        '&receivingAmount=' +
        searchParams.receivingAmount +
        '&status=' +
        searchParams.status;

    await axios
      .get(dataUrl, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((resp) => {
        setLoading(false);
        const newTransactions = resp.data.transactions.data;
        if (newTransactions.length > 0) {
          setTransactions((prevTransactions) => [
            ...prevTransactions,
            ...newTransactions,
          ]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          setHasMore(false); // No more data to load
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching data:', err.response);
        setLoading(false);
      });

    setLoading(true);
    await axios
      .get(Constants.BASE_URL + 'API-FX-200-FIELD-DETAILS', {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((resp) => {
        var fields = [];
        var values = [];
        for (var f = 0; resp.data.fields_details.length > 0; f++) {
          if (resp.data.fields_details[f].field_type == 1)
            fields.push({
              id: resp.data.fields_details[f].id,
              value: resp.data.fields_details[f].value,
            });
          else if (resp.data.fields_details[f].field_type == 2)
            values.push({
              id: resp.data.fields_details[f].id,
              value: resp.data.fields_details[f].value,
            });

          seteditFieldName(fields);
          seteditFieldValue(values);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
      });

    await axios
      .get(Constants.BASE_URL + 'API-FX-202-DOCUMENTS-LIST', {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((resp) => {
        var individual = [];
        var business = [];
        for (var d = 0; d < resp.data.documents.data.length; d++) {
          if (resp.data.documents.data[d].type == 'individual') {
            individual.push(resp.data.documents.data[d]);
          } else if (resp.data.documents.data[d].type == 'business') {
            business.push(resp.data.documents.data[d]);
          }
          setIndividual(individual);
          setBusiness(business);
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
    seteditFlag([
      'Green',
      'Red',
      'Blue',
      'Yellow',
      'Cyan',
      'Purple',
      'Gold',
      'Brown',
    ]);
    setedittypeOfDocuments([]);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleString();
  };

  useEffect(() => {
    getData(currentPage);
  }, []);

  const resolveSearchParams = (value) => {
    const trimmed = value.trim();
    const base = { sender: '', receiver: '', sendingAmount: '' };
    if (!trimmed) return base;
    if (/^\d+\.?\d*$/.test(trimmed)) return { ...base, sendingAmount: trimmed };
    return { ...base, sender: trimmed };
  };

  const handleCombinedSearchChange = useCallback(
    (value) => {
      setCombinedSearch(value);
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        const resolved = resolveSearchParams(value);
        const newParams = { ...searchText, ...resolved };
        setSearchText(newParams);
        setTransactions([]);
        setCurrentPage(1);
        setHasMore(true);
        setUiPage(1);
        getData(1, newParams);
      }, 500);
    },
    [searchText],
  );

  const handleTransactionIdChange = useCallback(
    (value) => {
      const newParams = { ...searchText, transactionId: value };
      setSearchText(newParams);

      if (txnIdDebounceRef.current) clearTimeout(txnIdDebounceRef.current);
      txnIdDebounceRef.current = setTimeout(() => {
        setTransactions([]);
        setCurrentPage(1);
        setHasMore(true);
        setUiPage(1);
        getData(1, newParams);
      }, 500);
    },
    [searchText],
  );
  const handleReceiverChange = useCallback(
    (value) => {
      const newParams = { ...searchText, receiver: value };
      setSearchText(newParams);

      if (receiverDebounceRef.current)
        clearTimeout(receiverDebounceRef.current);
      receiverDebounceRef.current = setTimeout(() => {
        setTransactions([]);
        setCurrentPage(1);
        setHasMore(true);
        setUiPage(1);
        getData(1, newParams);
      }, 500);
    },
    [searchText],
  );

  const clearCombinedSearch = () => {
    setCombinedSearch('');
    const resetParams = {
      transactionId: '',
      date: '',
      sender: '',
      receiver: '',
      sendingAmount: '',
      receivingAmount: '',
      status: searchText.status,
    };
    setSearchText(resetParams);
    setTransactions([]);
    setCurrentPage(1);
    setHasMore(true);
    setUiPage(1);
    getData(1, resetParams);
  };

  const reset = () => {
    setCombinedSearch('');
    const resetValues = {
      transactionId: '',
      date: '',
      sender: '',
      receiver: '',
      sendingAmount: '',
      receivingAmount: '',
      status: '',
    };
    setSearchText(resetValues);
    setTransactions([]);
    setCurrentPage(1);
    setHasMore(true);
    setUiPage(1);
    getData(1, resetValues);
  };

  const navigatetotransaction = async (
    payment_method,
    metaDetails,
    date,
    transactionid,
    transaction,
    transferfee,
    servicefee,
  ) => {
    handleShow();
    setChangeStatusTransactionId(transactionid);
    setChangeStatusWorkspaceId(transaction.workspace_id);
    setLoading(true);
    setedittypeOfDocuments([]);
    setuploadedDocuments([]);
    setPendingComplianceFiles([]);
    setTransferfee(transferfee ?? metaDetails?.transfer_fee ?? '');
    setServicefee(servicefee ?? metaDetails?.service_fee ?? '');
    setSellAmount(
      metaDetails?.conversion_meta?.conversion_partner_sell_amount ?? '',
    );
    setSellcurrency(
      metaDetails.conversion_meta?.conversion_sell_currency ?? '',
    );
    const token = sessionStorage.getItem('staff_login_token');
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-196-GET-TRANSACTION-DOCUMENTS',
        {
          transaction_id: transactionid,
        },
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        console.log(
          'RAW DOCUMENTS FROM API:',
          JSON.stringify(resp.data.documents, null, 2),
        );
        console.log(
          'KEYS OF FIRST DOC:',
          Object.keys(resp.data.documents[0] || {}),
        );
        console.log(
          'FULL DOC:',
          JSON.stringify(resp.data.documents[0], null, 2),
        );

        const docs = resp.data.documents || [];
        setuploadedDocuments(
          docs.map((doc) => ({
            ...doc,
            note: doc.note || '',
          })),
        );
      })
      .catch((err) => {
        console.log(err.response);
      });
    setRefId(transactionid);
    setCurrencysymbol(metaDetails.exchange_currency);
    setAmount(
      getCurrencySymbol(metaDetails.exchange_currency) +
        ' ' +
        metaDetails.recipient_amount,
    );
    setDate(date);
    transaction.type == 'debit';
    // ? setBeneName(metaDetails.second_beneficiary_name)
    // : setBeneName(metaDetails.sender_name);
    setBeneName(metaDetails.sender_name);
    setReceiverName(metaDetails.second_beneficiary_name);
    setcardFees(metaDetails.card_fees);
    setBeneBankNumber(metaDetails.second_beneficiary_bank_account_number);
    setBeneBankCodeValue(metaDetails.second_beneficiary_bank_code);
    setpaymentMethod(payment_method);
    setUserNotes(metaDetails.user_note);
    setComplianceNotes(metaDetails.compliance_note);
    setBeneId(metaDetails.beneficiary_id);
    setTransactionUserType(transaction.user_type);

    setTransactionType(transaction.type);
    setCreatedat(transaction.created_at);
    setUpdatedat(transaction.updated_at);
    setTransactionStatus(transaction.status);
    setTransferReason(metaDetails.reason);
    setCurrency(metaDetails.exchange_currency || transaction.settled_currency);
    setSenderNameDrawer(metaDetails.sender_name);
    setBeneficiaryNameDrawer(metaDetails.second_beneficiary_name);

    Object.prototype.hasOwnProperty.call(transaction, 'type_of_documents')
      ? setadminRequestedAttachments(transaction.type_of_documents)
      : setadminRequestedAttachments([]);

    Object.prototype.hasOwnProperty.call(metaDetails, 'user_attachment') &&
    metaDetails.user_attachment.length > 0
      ? setuserAttachment(
          metaDetails.user_attachment.map((item, index) => {
            const savedNotes = (metaDetails.user_note || '').split(' | ');
            return typeof item === 'string'
              ? { document: item, note: savedNotes[index] || '' }
              : item;
          }),
        )
      : setuserAttachment([]);
    setComplianceNotes(metaDetails.compliance_note || '');
    Object.prototype.hasOwnProperty.call(metaDetails, 'compliance_attachment')
      ? setcomplianceAttachment(metaDetails.compliance_attachment)
      : setcomplianceAttachment([]);

    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_trx_status') &&
      transaction.status != 'pending' &&
      setPaymentStatus(metaDetails.clearbank_trx_status.response.message);
    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_trx_status') &&
      transaction.status != 'pending' &&
      setPaymentId(metaDetails.clearbank_trx_status.response.id);
    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_trx_status') &&
      transaction.status != 'pending' &&
      setPaymentSubmitted('Clear Bank');

    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_response') &&
      transaction.status != 'pending' &&
      setPaymentStatus(metaDetails.clearbank_response.message);
    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_response') &&
      transaction.status != 'pending' &&
      setPaymentId(metaDetails.clearbank_response.id);
    Object.prototype.hasOwnProperty.call(metaDetails, 'clearbank_response') &&
      transaction.status != 'pending' &&
      setPaymentSubmitted('Clear Bank');

    Object.prototype.hasOwnProperty.call(
      metaDetails,
      'currency_cloud_payment_id',
    ) &&
      transaction.status != 'pending' &&
      setPaymentStatus(metaDetails.currency_cloud_status);
    Object.prototype.hasOwnProperty.call(
      metaDetails,
      'currency_cloud_payment_id',
    ) &&
      transaction.status != 'pending' &&
      setPaymentId(metaDetails.currency_cloud_payment_id);
    Object.prototype.hasOwnProperty.call(
      metaDetails,
      'currency_cloud_payment_id',
    ) &&
      transaction.status != 'pending' &&
      setPaymentSubmitted('Currency Cloud');
    setLoading(false);

    const parsedMeta = metaDetails;
    console.log('parsed meta', parsedMeta);
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const handleUserFileChange = async (event) => {
    const files = event.target.files;

    const filePromises = Array.from(files).map((file) =>
      convertFileToBase64(file),
    );

    try {
      const base64Files = await Promise.all(filePromises);
      const completedFiles = base64Files.map((f, index) => ({
        file: f.file,
        name: files[index].name,
        preview: URL.createObjectURL(files[index]),
        note: '',
      }));
      setedituserAttachment((prev) => [...prev, ...completedFiles]);
    } catch (error) {
      console.error('Error converting files to Base64:', error);
    }
  };

  const handleComplianceFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    Promise.all(files.map((file) => convertFileToBase64(file)))
      .then((base64Files) => {
        const newEntries = files.map((file, index) => ({
          file: base64Files[index], // { file: <base64 data URI>, extension }
          name: file.name,
          blobUrl: URL.createObjectURL(file),
        }));
        setPendingComplianceFiles((prev) => [...prev, ...newEntries]);
      })
      .catch((error) => {
        console.error('Error converting files to Base64:', error);
      });

    if (complianceFileInputRef.current) complianceFileInputRef.current.value = '';
  };

  const handleDeletePendingComplianceFile = (index) => {
    setPendingComplianceFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      var extension = file.name.split('.');
      reader.onload = () =>
        resolve({
          file: reader.result,
          extension: extension[extension.length - 1],
        });
      reader.onerror = (error) => reject(error);
    });
  };

  const saveData = async () => {
    setSave(true);
    const login_token = sessionStorage.getItem('staff_login_token');

    const allDocs = [
      ...uploadedDocuments.map((d) => ({
        note: d.note || '',
        source: 'saved',
      })),
      ...userAttachment.map((d) => ({
        note: d.note || '',
        source: 'existing',
      })),
      ...edituserAttachment.map((d) => ({ note: d.note || '', source: 'new' })),
    ];
    const combinedUserNotes =
      allDocs
        .map((d) => d.note)
        .filter(Boolean)
        .join(' | ') || 'NA';

    try {
      const encryptedPayload = await encryptPayload({
          flag: editSelectedflag,
          user_attachments: edituserAttachment,
          user_notes: combinedUserNotes,
          compliance_attachments: pendingComplianceFiles.map(
            ({ file, name }) => ({
              file,
              name,
            }),
          ),
          compliance_notes: editcomplianceNotes ?? 'NA',
          field_name: editfieldSelectedName,
          field_value: editfieldSelectedValue,
          type_of_documents: edittypeOfDocuments,
          deleted_user_attachments: deletedUserAttachments,
          deleted_compliance_attachments: deletedComplianceAttachments,
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });

      const response = await axios.post(
        `${Constants.BASE_URL}API-FX-201-STORE-COMPLIANCE-TRANSACTION-DETAILS/${refId}`,
        encryptedPayload,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(login_token)}`,
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      console.log('Save Response:', response.data);
      setLoading(false);
      toast.success('Successfully Saved.');
      setTransactions([]);
      getData(1);
      setCurrentPage(1);
      setEdit(false);
      setedituserAttachment([]);
      setDeletedUserAttachments([]);
      setDeletedComplianceAttachments([]);
      setPendingComplianceFiles([]);
      handleClose();
    } catch (error) {
      console.error('Status:', error.response?.status);
      console.error('Status Text:', error.response?.statusText);
      console.error(
        'Error Data:',
        JSON.stringify(error.response?.data, null, 2),
      );
      console.error('Headers sent:', error.config?.headers);
      toast.error(
        `Failed to save: ${error.response?.status} — ${JSON.stringify(error.response?.data?.message || error.response?.data)}`,
      );
    } finally {
      setSave(false);
    }
  };
  const openBene = async (beneId) => {
    window.open('/DebitTransactions?beneficiary_id=' + beneId);
  };
  const submitTopayOut = async () => {
    if (payoutButton != 'Submitting...') {
      setpayoutButton('Submitting...');
      const login_token = sessionStorage.getItem('staff_login_token');
      const userId = sessionStorage.getItem('staff_login_id');
      await axios
        .post(
          Constants.BASE_URL + 'API-FX-207-SUBMIT-PAYMENT',
          {
            id: refId,
            userId: JSON.parse(userId),
          },
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(login_token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        )
        .then((resp) => {
          toast.success(resp.data.message);
          setTransactions([]);
          handleClose();
          getData(1);
          setpayoutButton('Submitted');
        })
        .catch((err) => {
          toast.error(err.response.data.message);
          setTransactions([]);
          handleClose();
          getData(1);
          setpayoutButton('Error Submitting');
        });
    }
  };

  const paginatedTransactions = (() => {
    if (fromHome) return transactions.slice(0, 5);
    const start = (uiPage - 1) * ITEMS_PER_PAGE;
    return transactions.slice(start, start + ITEMS_PER_PAGE);
  })();
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] to-[#eef2ff66] px-6 py-10 font-sans">
      <ToastContainer />

      <ChangeStatusDialog
        isOpen={openStatusDialog}
        onClose={() => setOpenStatusDialog(false)}
        transactionId={changeStatusTransactionId}
        workspaceId={changeStatusWorkspaceId}
      />

      <h1 className="text-center text-2xl font-bold text-[#1D2338] mb-6 tracking-tight">
        Debit Transactions
      </h1>

      <div className="max-w-5xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
        <div className="mb-4 space-y-3">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center bg-white border border-gray-200 rounded-xl px-3.5 h-10 gap-2 flex-1 min-w-[220px] focus-within:border-gray-400 transition-colors">
              <FiSearch size={13} className="text-gray-400 flex-shrink-0" />
              <input
                type="text"
                placeholder="Search by Sender Name or Amount"
                value={combinedSearch}
                onChange={(e) => handleCombinedSearchChange(e.target.value)}
                className="border-none outline-none text-[13px] text-gray-700 bg-transparent w-full placeholder-gray-400 font-sans"
              />
              {combinedSearch && (
                <button
                  onClick={clearCombinedSearch}
                  className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                  title="Clear search"
                >
                  <FiX size={13} />
                </button>
              )}
            </div>

            <button
              onClick={() => setShowFilterDropdown((v) => !v)}
              title="Advanced Filters"
              className={`flex items-center justify-center w-10 h-10 rounded-xl border transition-all flex-shrink-0 relative
              ${
                showFilterDropdown ||
                searchText.status ||
                searchText.date ||
                searchText.transactionId ||
                searchText.receiver
                  ? 'border-[#0B214E] text-[#0B214E] bg-blue-50'
                  : 'border-gray-200 text-gray-500 bg-white hover:border-[#0B214E] hover:text-[#0B214E] hover:bg-blue-50'
              }`}
            >
              <FiFilter size={15} />
              {(searchText.status ||
                searchText.date ||
                searchText.transactionId ||
                searchText.receiver) && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-orange-500 rounded-full border-2 border-white" />
              )}
            </button>
          </div>

          {showFilterDropdown && (
            <div
              ref={filterRef}
              className="w-full bg-white border border-gray-200 rounded-xl p-4"
            >
              <p className="text-[11px] font-semibold text-gray-500 tracking-wider mb-3">
                Advanced Filters
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-4">
                <div>
                  <label className="text-[11px] font-semibold text-gray-500 block mb-1.5">
                    Transaction ID
                  </label>
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 h-10 focus-within:border-gray-400 transition-colors bg-gray-50">
                    <input
                      type="text"
                      placeholder="Search By Transaction Id"
                      value={searchText.transactionId}
                      onChange={(e) =>
                        handleTransactionIdChange(e.target.value)
                      }
                      className="border-none outline-none text-sm text-gray-700 bg-transparent w-full font-sans"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[11px] font-semibold text-gray-500 block mb-1.5">
                    Receiver Name
                  </label>
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 h-10 focus-within:border-gray-400 transition-colors bg-gray-50">
                    <input
                      type="text"
                      placeholder="Search by Receiver Name"
                      value={searchText.receiver}
                      onChange={(e) => handleReceiverChange(e.target.value)}
                      className="border-none outline-none text-sm text-gray-700 bg-transparent w-full font-sans"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[11px] font-semibold text-gray-500 tracking-wider block mb-1.5">
                    Date
                  </label>
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 h-10 focus-within:border-gray-400 transition-colors bg-gray-50">
                    <input
                      type="date"
                      max={new Date().toISOString().split('T')[0]}
                      value={searchText.date}
                      onChange={(e) => {
                        const newDate = e.target.value;
                        const newParams = { ...searchText, date: newDate };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(1);
                        setHasMore(true);
                        setUiPage(1);
                        getData(1, newParams);
                      }}
                      className="border-none outline-none text-sm text-gray-700 bg-transparent w-full font-sans cursor-pointer"
                    />
                  </div>
                  {searchText.date && (
                    <button
                      onClick={() => {
                        const newParams = { ...searchText, date: '' };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(1);
                        setHasMore(true);
                        setUiPage(1);
                        getData(1, newParams);
                      }}
                      className="mt-1.5 text-xs text-red-500 font-semibold hover:text-red-700 transition-colors"
                    >
                      Clear date
                    </button>
                  )}
                </div>

                <div>
                  <label className="text-[11px] font-semibold text-gray-500 tracking-wider block mb-1.5">
                    Status
                  </label>
                  <select
                    value={searchText.status}
                    onChange={(e) => {
                      const newParams = {
                        ...searchText,
                        status: e.target.value,
                      };
                      setSearchText(newParams);
                      setTransactions([]);
                      setCurrentPage(1);
                      setHasMore(true);
                      setUiPage(1);
                      getData(1, newParams);
                    }}
                    className="w-full h-10 border border-gray-200 rounded-lg px-3 text-sm text-gray-700 bg-gray-50 outline-none focus:border-gray-400 transition-colors font-sans cursor-pointer"
                  >
                    <option value="" className="hidden">
                      Status
                    </option>
                    {STATUS_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                  {searchText.status && (
                    <button
                      onClick={() => {
                        const newParams = { ...searchText, status: '' };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(1);
                        setHasMore(true);
                        setUiPage(1);
                        getData(1, newParams);
                      }}
                      className="mt-1.5 text-xs text-red-500 font-semibold hover:text-red-700 transition-colors"
                    >
                      Clear status
                    </button>
                  )}
                </div>
              </div>

              {(searchText.date ||
                searchText.status ||
                searchText.transactionId ||
                searchText.receiver) && (
                <div className="flex justify-end border-t border-gray-100 pt-3">
                  <button
                    onClick={() => {
                      reset();
                      setShowFilterDropdown(false);
                    }}
                    className="text-xs text-gray-500 font-semibold hover:text-gray-700 transition-colors"
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>
          )}

          {(searchText.date || searchText.status) && (
            <div className="flex items-center gap-2 flex-wrap">
              {searchText.date && (
                <span className="flex items-center gap-1.5 bg-blue-50 text-[#0B214E] rounded-full px-3 py-1 text-xs font-semibold">
                  Date: {searchText.date}
                  <span
                    className="cursor-pointer font-bold text-sm opacity-60 hover:opacity-100 leading-none"
                    onClick={() => {
                      const newParams = { ...searchText, date: '' };
                      setSearchText(newParams);
                      setTransactions([]);
                      setCurrentPage(1);
                      setHasMore(true);
                      setUiPage(1);
                      getData(1, newParams);
                    }}
                  >
                    ×
                  </span>
                </span>
              )}
              {searchText.status && (
                <span className="flex items-center gap-1.5 bg-blue-50 text-[#0B214E] rounded-full px-3 py-1 text-xs font-semibold capitalize">
                  Status: {searchText.status}
                  <span
                    className="cursor-pointer font-bold text-sm opacity-60 hover:opacity-100 leading-none"
                    onClick={() => {
                      const newParams = { ...searchText, status: '' };
                      setSearchText(newParams);
                      setTransactions([]);
                      setCurrentPage(1);
                      setHasMore(true);
                      setUiPage(1);
                      getData(1, newParams);
                    }}
                  >
                    ×
                  </span>
                </span>
              )}
              <button
                onClick={reset}
                className="text-red-500 font-semibold text-xs hover:text-red-700 bg-transparent border-none cursor-pointer px-1"
              >
                Clear all
              </button>
            </div>
          )}
        </div>

        {loading && transactions.length === 0 ? (
          <div className="rounded-xl border border-gray-200 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="h-[68px] border-b border-gray-100 last:border-b-0"
                style={{
                  background:
                    'linear-gradient(90deg,#f5f6f8 25%,#edeef0 50%,#f5f6f8 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 1.5s infinite',
                }}
              />
            ))}
            <style>{`@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
          </div>
        ) : pageLoading ? (
          <PageSpinner />
        ) : noResultsFound ? (
          <div className="text-center py-16 text-gray-400">
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              className="mx-auto mb-3 opacity-30"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <p className="font-semibold text-sm text-gray-700 mb-1">
              No records found
            </p>
            <p className="text-xs">Try adjusting your search or filters.</p>
          </div>
        ) : (
          <>
            <div className="rounded-xl border border-gray-200 overflow-hidden">
              {paginatedTransactions.map((beneficiary, idx) => {
                console.log('Beneficiary Data', beneficiary);
                const meta = beneficiary.meta || {};
                const transferfee = meta?.transfer_fee;
                const servicefee = meta?.service_fee;
                const receivingAmount = meta.recipient_amount || 0;
                const receivingCurrency = meta.exchange_currency || '';
                const createddate = new Date(beneficiary.created_at);
                const isToday =
                  new Date().toDateString() === createddate.toDateString();
                const formatteddate = isToday
                  ? 'Today'
                  : createddate.getDate() +
                    '-' +
                    (createddate.getMonth() + 1) +
                    '-' +
                    createddate.getFullYear();
                const formattedtime = createddate.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                });
                const statusStyle = getStatusStyle(beneficiary.status);
                const isHovered = hoveredRow === beneficiary.id;
                const iconBgClass = getIconBg(
                  beneficiary.type,
                  beneficiary.status,
                );

                const needsUpload =
                  beneficiary.id in documents &&
                  ['pending', 'review'].includes(
                    String(beneficiary.status || '').toLowerCase(),
                  );

                return (
                  <div key={beneficiary.id}>
                    <div
                      className={`flex items-center gap-3 px-4 py-3.5 border-b border-gray-100 last:border-b-0 transition-colors ${
                        isHovered
                          ? 'bg-blue-50/40'
                          : idx % 2 === 0
                            ? 'bg-white'
                            : 'bg-gray-50/60'
                      }`}
                      onMouseEnter={() => setHoveredRow(beneficiary.id)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      <div
                        className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${iconBgClass}`}
                      >
                        {renderIcon(beneficiary)}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div
                          className="font-semibold text-[13.5px] text-[#1D2338] cursor-pointer hover:text-[#0B214E] truncate max-w-[280px] mb-0.5"
                          onClick={() =>
                            navigatetotransaction(
                              beneficiary.payment_method,
                              beneficiary.meta,
                              formatteddate,
                              beneficiary.id,
                              beneficiary,
                              transferfee,
                              servicefee,
                            )
                          }
                        >
                          {meta.sender_name}
                          <span className="mx-2 text-gray-400">→</span>
                          {meta.second_beneficiary_name}
                        </div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="inline-block bg-gray-100 text-gray-500 rounded px-1.5 py-0.5 text-[10.5px] font-medium">
                            ID: {beneficiary.id}
                          </span>
                          <span className="text-[11px] text-gray-400">
                            {formatteddate} at {formattedtime}
                          </span>
                          <span className="inline-block bg-gray-100 text-gray-500 rounded px-1.5 py-0.5 text-[10.5px] font-medium">
                            Sending:{' '}
                            {getCurrencySymbol(
                              beneficiary.meta?.conversion_meta
                                ?.conversion_sell_currency,
                            )}
                            {numberWithCommas(
                              parseFloat(
                                beneficiary.meta?.conversion_meta
                                  ?.conversion_partner_sell_amount || 0,
                              ).toFixed(2),
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="text-right flex-shrink-0 min-w-[120px] flex flex-col items-end gap-1.5">
                        <div className="text-sm font-bold text-[#1D2338]">
                          {getCurrencySymbol(receivingCurrency)}
                          {numberWithCommas(
                            parseFloat(receivingAmount || 0).toFixed(2),
                          )}
                        </div>
                        <span
                          className={`inline-flex items-center justify-center px-3 py-0.5 rounded-md text-[11.5px] font-semibold whitespace-nowrap min-w-[80px] ${statusStyle.bg} ${statusStyle.color}`}
                        >
                          {statusStyle.label}
                        </span>
                      </div>
                      <div className="flex items-center gap-1.5 flex-shrink-0">
                        {needsUpload && showUploadRow !== beneficiary.id && (
                          <button
                            className="flex items-center gap-1.5 bg-white text-gray-600 border border-gray-200 hover:border-gray-400 hover:bg-gray-50 rounded-lg px-3 py-1.5 text-xs font-medium whitespace-nowrap transition-colors"
                            onClick={() => setShowUploadRow(beneficiary.id)}
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                              <polyline points="17 8 12 3 7 8" />
                              <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Upload Document
                          </button>
                        )}

                        <button
                          className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-800 transition-all flex-shrink-0"
                          title="View details"
                          onClick={() =>
                            navigatetotransaction(
                              beneficiary.payment_method,
                              beneficiary.meta,
                              new Date(
                                beneficiary.created_at,
                              ).toLocaleDateString(),
                              beneficiary.id,
                              beneficiary,
                              transferfee,
                              servicefee,
                            )
                          }
                        >
                          <FiEye size={13} />
                        </button>
                      </div>
                    </div>
                    {needsUpload && showUploadRow === beneficiary.id && (
                      <div
                        className={`px-4 py-4 border-b border-gray-100 ${
                          idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'
                        }`}
                      >
                        <p className="text-xs font-semibold text-gray-500 mb-3 uppercase tracking-wider">
                          Upload Required Documents
                        </p>
                        <div className="flex gap-3 flex-wrap">
                          {documents[beneficiary.id]?.map((doc, index) => (
                            <div
                              key={index}
                              className="border border-dashed border-blue-400 p-3 rounded-xl w-48 text-xs bg-blue-50/30"
                            >
                              {doc.uploaded_document ? (
                                <span className="text-emerald-600 font-semibold flex items-center gap-1.5">
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#16a34a"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                  {doc.document} uploaded
                                </span>
                              ) : (
                                <>
                                  <label className="font-semibold text-gray-700 block mb-2">
                                    {doc.document}
                                  </label>
                                  <input
                                    type="file"
                                    className="w-full text-[11px] text-gray-600 file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                    onChange={(e) =>
                                      handleFileChange(
                                        e,
                                        doc.document,
                                        beneficiary.id,
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                        <div className="flex items-center gap-2 mt-4">
                          <button
                            className="bg-blue-600 text-white px-4 py-1.5 rounded-lg text-xs font-semibold hover:bg-blue-700 disabled:opacity-60 transition-colors"
                            onClick={() => handleUpload(beneficiary.id)}
                            disabled={uploading}
                          >
                            {uploading ? 'Uploading...' : 'Submit'}
                          </button>
                          <button
                            className="bg-white text-gray-500 border border-gray-200 px-4 py-1.5 rounded-lg text-xs font-semibold hover:border-gray-400 transition-colors"
                            onClick={() => setShowUploadRow(null)}
                            disabled={uploading}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}

        {!fromHome && (
          <div className="flex items-center justify-end gap-1.5 pt-4 border-t border-gray-100 mt-1 flex-wrap">
            <button
              className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] disabled:opacity-30 disabled:cursor-not-allowed transition-all"
              onClick={() => handlePageChange(uiPage - 1)}
            >
              <FiChevronLeft size={13} />
            </button>

            {(() => {
              const pages = [];
              const range = 2;
              let start = Math.max(1, uiPage - range);
              let end = Math.min(totalPages, uiPage + range);
              if (uiPage <= range + 1)
                end = Math.min(totalPages, 2 * range + 1);
              if (uiPage >= totalPages - range)
                start = Math.max(1, totalPages - 2 * range);

              if (start > 1) {
                pages.push(
                  <button
                    key={1}
                    className="w-8 h-8 rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] transition-all"
                    onClick={() => handlePageChange(1)}
                  >
                    1
                  </button>,
                );
                if (start > 2)
                  pages.push(
                    <span key="e1" className="px-1 text-gray-400 text-sm">
                      …
                    </span>,
                  );
              }
              for (let i = start; i <= end; i++) {
                const isNextPageDisabled = i > uiPage && !currentPageComplete;
                pages.push(
                  <button
                    key={i}
                    onClick={() => !isNextPageDisabled && handlePageChange(i)}
                    disabled={pageLoading || isNextPageDisabled}
                    className={`w-8 h-8 rounded-lg border text-sm font-medium transition-all
                                  ${
                                    uiPage === i
                                      ? 'bg-[#0B214E] text-white border-[#0B214E] font-bold'
                                      : isNextPageDisabled
                                        ? 'border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed'
                                        : 'border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E]'
                                  } disabled:opacity-50`}
                  >
                    {i}
                  </button>,
                );
              }
              if (end < totalPages) {
                if (end < totalPages - 1)
                  pages.push(
                    <span key="e2" className="px-1 text-gray-400 text-sm">
                      …
                    </span>,
                  );
                pages.push(
                  <button
                    key={totalPages}
                    disabled={!currentPageComplete || pageLoading}
                    className={`w-8 h-8 rounded-lg border text-sm font-medium transition-all
                                  ${
                                    !currentPageComplete
                                      ? 'border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed'
                                      : 'border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E]'
                                  }`}
                    onClick={() =>
                      currentPageComplete && handlePageChange(totalPages)
                    }
                  >
                    {totalPages}
                  </button>,
                );
              }
              return pages;
            })()}

            <button
              className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] disabled:opacity-30 disabled:cursor-not-allowed transition-all"
              onClick={() => handlePageChange(uiPage + 1)}
              disabled={(uiPage >= totalPages && !hasMore) || pageLoading}
            >
              <FiChevronRight size={13} />
            </button>

            <span className="text-xs text-gray-400 ml-2">
              {(uiPage - 1) * ITEMS_PER_PAGE + 1}–
              {Math.min(uiPage * ITEMS_PER_PAGE, transactions.length)} of{' '}
              {transactions.length}
              {hasMore ? '+' : ''}
            </span>
          </div>
        )}

        {fromHome && transactions.length > 5 && (
          <div className="text-right pt-3 border-t border-gray-100 mt-1">
            <button
              onClick={() => navigate('/DebitTransactions')}
              className="text-blue-700 font-semibold text-sm hover:text-blue-900 transition-colors bg-transparent border-none cursor-pointer"
            >
              View All →
            </button>
          </div>
        )}
      </div>
      <div
        className={`fixed top-0 right-0 h-full bg-[#EEEDEB] shadow-lg z-50 transition-transform duration-300 overflow-y-auto ${
          show ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ width: '100%' }}
      >
        {
          <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] to-[#eef2ff66] py-4 md:py-8 px-3 md:px-4">
            <div className="max-w-[800px] mx-auto">
              <div className="text-center">
                <h1 className="text-xl md:text-2xl lg:text-[28px] font-[700] text-[#1f2a44] leading-tight md:leading-[34px]">
                  Debit Transaction Details
                </h1>
              </div>
              <button
                onClick={handleClose}
                className="flex items-center gap-2 mt-3 md:mt-5 mb-3 md:mb-5 text-sm md:text-[15px] font-[600] text-[#1f2a44]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 19.5L8.25 12l7.5-7.5"
                  />
                </svg>
                Back
              </button>

              <div className="border-[1.5px] border-[#e2e8f0] bg-white rounded-lg md:rounded-[16px] overflow-hidden p-3 md:p-4">
                <div className="flex flex-col md:flex-row items-start justify-between gap-3 md:gap-0 pb-3 md:pb-4">
                  <div className="flex items-start md:items-center gap-2 md:gap-3 w-full">
                    <img
                      src="https://avataaars.io/?avatarStyle=Circle"
                      alt="Profile"
                      className="w-8 md:w-10 h-8 md:h-10 rounded-full flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:gap-4">
                        <p className="text-sm md:text-[15px] font-[600] text-[#1D2338] break-words">
                          {beneName}
                          <span className="mx-1 md:mx-2 text-[#000000] text-base md:text-[16px]">
                            →
                          </span>
                          {receiverName}
                        </p>

                        <span className="text-base md:text-[18px] font-[700] text-[#1D2338] whitespace-nowrap flex-shrink-0">
                          {CURRENCY_SYMBOLS[currencysymbol]}{' '}
                          {parseFloat(
                            String(amount).replace(/[^\d.-]/g, ''),
                          ).toFixed(2)}
                        </span>
                      </div>

                      <p className="text-xs md:text-[12px] text-[#8F959F] mt-2">
                        Sent on :{' '}
                        <span className="text-sm md:text-[14px] font-[500] text-[#1D2338]">
                          {date}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-3 md:mt-4 border-[1.5px] border-[#e2e8f0] bg-[#FCFCFC] rounded-lg md:rounded-[12px] p-3 md:p-4">
                  <h3 className="text-sm md:text-[14px] font-[700] text-[#203358] mb-3 md:mb-4">
                    Transaction Details
                  </h3>
                  <div className="space-y-2 md:space-y-3">
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Transaction ID
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {refId}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Created At
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {formatDate(createdat)}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Updated At
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {formatDate(updatedat)}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Type
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {transactionType}
                      </span>
                    </div>
                    {sellamount.trim() !== '' && (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Sell Amount
                        </span>

                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          {getCurrencySymbol(sellcurrency)} {sellamount}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        {sellamount.trim() !== '' ? 'Receive Amount' : 'Amount'}
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {amount}
                      </span>
                    </div>
                    {transferfee !== '' && transferfee !== null && (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Transfer Fee
                        </span>
                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          {getCurrencySymbol(sellcurrency)}
                          {transferfee}
                        </span>
                      </div>
                    )}
                    {servicefee !== null && servicefee !== '' && (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Service Fee
                        </span>
                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          {getCurrencySymbol(sellcurrency)}
                          {servicefee}
                        </span>
                      </div>
                    )}
                    {sellamount.trim() !== '' && (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Total Amount
                        </span>
                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          {getCurrencySymbol(sellcurrency)}
                          {(
                            parseFloat(sellamount || 0) +
                            (transferfee !== '' &&
                            transferfee !== null &&
                            !isNaN(parseFloat(transferfee))
                              ? parseFloat(transferfee)
                              : 0) +
                            (servicefee !== '' &&
                            servicefee !== null &&
                            !isNaN(parseFloat(servicefee))
                              ? parseFloat(servicefee)
                              : 0)
                          ).toFixed(2)}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Date & Time
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {date}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Currency
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {currency}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Status
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {transactionStatus}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs md:text-[13px] gap-2">
                      <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                        Transfer Reason
                      </span>
                      <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                        {transferReason}
                      </span>
                    </div>
                    {cardFees != '' && cardFees != null && (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Fees
                        </span>
                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          GBP {cardFees}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="mt-4 md:mt-6">
                    <h3 className="text-sm md:text-[14px] font-[700] text-[#203358] mb-3 md:mb-4">
                      {transactionType === 'debit'
                        ? 'Beneficiary Details'
                        : 'Sender Details'}
                    </h3>
                    {transactionType === 'debit' ? (
                      <div className="space-y-2 md:space-y-3">
                        <div className="flex justify-between text-xs md:text-[13px] gap-2">
                          <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                            Account Name
                          </span>
                          <button
                            className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right hover:underline"
                            onClick={() => openBene(beneId)}
                          >
                            {beneficiaryNameDrawer}
                          </button>
                        </div>
                        {beneBankNumber != '' && beneBankNumber != null && (
                          <div className="flex justify-between text-xs md:text-[13px] gap-2">
                            <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                              Account Number
                            </span>
                            <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                              {beneBankNumber}
                            </span>
                          </div>
                        )}
                        {beneBankCodeValue != '' &&
                          beneBankCodeValue != null && (
                            <div className="flex justify-between text-xs md:text-[13px] gap-2">
                              <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                                Code
                              </span>
                              <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                                {beneBankCodeValue}
                              </span>
                            </div>
                          )}
                      </div>
                    ) : (
                      <div className="flex justify-between text-xs md:text-[13px] gap-2">
                        <span className="text-[#676F7D] text-sm md:text-[14px] font-[400]">
                          Sender Name
                        </span>
                        <span className="text-[#1D2338] text-sm md:text-[14px] font-[600] text-right">
                          {senderNameDrawer}
                        </span>
                      </div>
                    )}
                  </div>

                  {!loading && (
                    <div className="mt-4 border border-[#E6E5E5] rounded-lg md:rounded-[12px] overflow-hidden bg-[#FCFCFC]">
                      <div
                        onClick={() => setShownotes(!shownotes)}
                        className="px-2 md:px-3 py-2 md:py-3 bg-[#FAFAFA] border-b cursor-pointer"
                      >
                        <h2 className="text-sm md:text-[14px] font-[700] text-[#203358]">
                          Notes & Attachments
                        </h2>
                      </div>

                      {shownotes && (
                        <div className="p-3 md:p-4">
                          {edit && (
                            <div className="mb-3 md:mb-4">
                              <label className="text-xs md:text-[13px] font-[600] text-[#2563EB] cursor-pointer flex items-center gap-2">
                                ⬆ Upload Documents
                                <input
                                  type="file"
                                  hidden
                                  ref={userFileInputRef}
                                  multiple
                                  accept=".jpg,.jpeg,.png,.pdf"
                                  onChange={handleUserFileChange}
                                />
                              </label>
                              <p className="text-[10px] md:text-[11px] text-[#9CA3AF] mt-1">
                                Supported Format : JPG, PNG, PDF (Max 8MB)
                              </p>
                            </div>
                          )}
                          {uploadedDocuments.filter((d) => !!d.document)
                            .length > 0 && (
                            <div className="space-y-2 md:space-y-3 mb-3 md:mb-4">
                              <p className="text-[11px] md:text-[12px] font-[600] text-[#6B7280] mb-1">
                                Saved Documents (
                                {
                                  uploadedDocuments.filter((d) => !!d.document)
                                    .length
                                }
                                )
                              </p>

                              {uploadedDocuments.length > 0 && (
                                <div className="space-y-2 md:space-y-3 mb-3 md:mb-4">
                                  <p className="text-[11px] md:text-[12px] font-[600] text-[#6B7280] mb-2">
                                    Uploaded Documents (
                                    {uploadedDocuments.length})
                                  </p>
                                  {uploadedDocuments.map((doc, index) => {
                                    const isSaved = !!doc.document;
                                    const isEditing = editingDocIndex === index;

                                    return (
                                      <div
                                        key={`saved-${index}`}
                                        className="border border-[#E5E7EB] rounded-lg md:rounded-[10px] p-2 md:p-3 bg-white"
                                      >
                                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 md:gap-3 mb-2 md:mb-3">
                                          <div className="flex-1 min-w-0">
                                            <p className="text-xs md:text-[13px] font-[600] text-[#1F2A44] truncate">
                                              {doc.document_name ||
                                                doc.document ||
                                                `Document ${index + 1}`}
                                            </p>
                                            <p className="text-[10px] md:text-[11px] text-[#9CA3AF]">
                                              {doc.type || 'JPG, PNG, PDF'}
                                              {doc.size
                                                ? ` · ${(doc.size / 1024).toFixed(1)} KB`
                                                : ''}
                                            </p>
                                          </div>

                                          <div className="flex items-center gap-1 md:gap-2 flex-wrap justify-end w-full sm:w-auto">
                                            {isSaved && (
                                              <a
                                                href={
                                                  Constants.FILE_PATH_BASE_URL +
                                                  doc.document
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-white bg-[#2563EB] text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] hover:bg-blue-700 transition-colors whitespace-nowrap"
                                              >
                                                View
                                              </a>
                                            )}

                                            {!isSaved && (
                                              <span className="text-[#9CA3AF] text-[11px] md:text-[12px] bg-gray-100 px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] whitespace-nowrap">
                                                Pending upload
                                              </span>
                                            )}

                                            {isSaved && !isEditing && (
                                              <button
                                                onClick={() =>
                                                  setEditingDocIndex(index)
                                                }
                                                disabled={!edit}
                                                className="text-[11px] md:text-[12px] font-[600] text-[#6B7280] border border-[#E5E7EB] rounded-[6px] px-2 md:px-2.5 py-1 md:py-1 hover:bg-gray-50 transition-colors whitespace-nowrap"
                                              >
                                                Edit Note
                                              </button>
                                            )}

                                            {isSaved && isEditing && (
                                              <div className="flex items-center gap-1 md:gap-2 flex-wrap">
                                                <button
                                                  onClick={() => {
                                                    setEditingDocIndex(null);
                                                    toast.success(
                                                      'Note updated locally. Click Save to persist.',
                                                    );
                                                  }}
                                                  className="text-[11px] md:text-[12px] font-[600] text-white bg-[#D86B1F] rounded-[6px] px-2 md:px-2.5 py-1 md:py-1 hover:bg-orange-600 transition-colors whitespace-nowrap"
                                                >
                                                  Done
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleDeleteDoc(index)
                                                  }
                                                  disabled={!edit}
                                                  className={`text-white text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] whitespace-nowrap ${
                                                    edit
                                                      ? 'bg-red-500 hover:bg-red-600 cursor-pointer'
                                                      : 'bg-red-300 cursor-not-allowed'
                                                  }`}
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            )}

                                            {!isSaved && (
                                              <button
                                                onClick={() =>
                                                  handleDeleteDoc(index)
                                                }
                                                disabled={!edit}
                                                className={`text-white text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] whitespace-nowrap ${
                                                  edit
                                                    ? 'bg-red-500 hover:bg-red-600 cursor-pointer'
                                                    : 'bg-red-300 cursor-not-allowed'
                                                }`}
                                              >
                                                Delete
                                              </button>
                                            )}
                                          </div>
                                        </div>

                                        <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-[#E5E7EB]">
                                          <label className="text-[10px] md:text-[11px] font-[600] text-[#6B7280] block mb-1 md:mb-2">
                                            Notes
                                          </label>
                                          <input
                                            type="text"
                                            placeholder="Add or view notes for this document..."
                                            value={doc.note || ''}
                                            onChange={(e) =>
                                              handleLocalNoteChange(
                                                index,
                                                e.target.value,
                                                false,
                                              )
                                            }
                                            disabled={!edit && !isEditing}
                                            className={`w-full h-8 md:h-[36px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px] transition-colors ${
                                              edit || isEditing
                                                ? 'bg-white focus:outline-none focus:ring-2 focus:ring-blue-500'
                                                : 'bg-gray-50 text-gray-700 cursor-not-allowed'
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                          {edituserAttachment.length > 0 && (
                            <div className="mb-3 md:mb-4">
                              <p className="text-[11px] md:text-[12px] font-[600] text-[#6B7280] mb-2">
                                New Uploads — Pending Save (
                                {edituserAttachment.length})
                              </p>
                              {edituserAttachment.map((file, index) => (
                                <div
                                  key={`new-${index}`}
                                  className="border border-[#E5E7EB] rounded-lg md:rounded-[10px] p-2 md:p-3 bg-blue-50 mb-2 md:mb-3"
                                >
                                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 md:gap-3 mb-2 md:mb-2">
                                    <div className="flex-1 min-w-0">
                                      <p className="text-xs md:text-[13px] font-[600] text-[#1F2A44] truncate">
                                        {file.name || `Document ${index + 1}`}
                                      </p>
                                      <p className="text-[10px] md:text-[11px] text-[#9CA3AF]">
                                        Ready to upload
                                      </p>
                                    </div>
                                    <div className="flex items-center gap-1 md:gap-2 flex-wrap justify-end w-full sm:w-auto">
                                      {file.preview && (
                                        <a
                                          href={file.preview}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="text-white bg-[#2563EB] text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] hover:bg-blue-700 transition-colors whitespace-nowrap"
                                        >
                                          View
                                        </a>
                                      )}
                                      <button
                                        onClick={() => {
                                          setedituserAttachment((prev) =>
                                            prev.filter((_, i) => i !== index),
                                          );
                                          toast.info('Document removed');
                                        }}
                                        className="text-white bg-red-500 text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] hover:bg-red-600 transition-colors whitespace-nowrap"
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>

                                  <div className="pt-2 md:pt-2 border-t border-blue-200">
                                    <label className="text-[10px] md:text-[11px] font-[600] text-[#6B7280] block mb-1">
                                      Notes
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Add notes for this document..."
                                      value={file.note || ''}
                                      onChange={(e) =>
                                        handleLocalNoteChange(
                                          index,
                                          e.target.value,
                                          true,
                                        )
                                      }
                                      className="w-full h-8 md:h-[36px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px] bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          {userAttachment.length > 0 && (
                            <div className="space-y-2 md:space-y-3 mb-3 md:mb-4">
                              <p className="text-[11px] md:text-[12px] font-[600] text-[#203358] mb-2">
                                User Attachments ({userAttachment.length})
                              </p>
                              {userAttachment.map((doc, index) => (
                                <div
                                  key={index}
                                  className="border border-[#E5E7EB] rounded-lg md:rounded-[10px] p-2 md:p-3 bg-white"
                                >
                                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 md:gap-3">
                                    <p className="text-xs md:text-[13px] font-[600] text-[#1F2A44]">
                                      Attachment {index + 1}
                                    </p>
                                    <div className="flex items-center gap-1 md:gap-2 flex-wrap justify-end w-full sm:w-auto">
                                      <a
                                        href={
                                          Constants.FILE_PATH_BASE_URL +
                                          doc.document
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-white bg-[#2563EB] text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] hover:bg-blue-700 whitespace-nowrap"
                                      >
                                        View
                                      </a>
                                      <button
                                        onClick={() => {
                                          setDeletedUserAttachments((prev) => [
                                            ...prev,
                                            doc.document,
                                          ]);
                                          setuserAttachment((prev) =>
                                            prev.filter((_, i) => i !== index),
                                          );
                                        }}
                                        disabled={!edit}
                                        className={`text-white text-[11px] md:text-[12px] font-[600] px-2 md:px-3 py-1 md:py-1.5 rounded-[6px] whitespace-nowrap ${
                                          edit
                                            ? 'bg-red-500 hover:bg-red-600 cursor-pointer'
                                            : 'bg-red-300 cursor-not-allowed'
                                        }`}
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                  <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-[#E5E7EB]">
                                    <label className="text-[10px] md:text-[11px] font-[600] text-[#6B7280] block mb-1 md:mb-2">
                                      Notes
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Add or view notes for this document..."
                                      value={doc.note || ''}
                                      onChange={(e) =>
                                        setuserAttachment((prev) =>
                                          prev.map((item, i) =>
                                            i === index
                                              ? {
                                                  ...item,
                                                  note: e.target.value,
                                                }
                                              : item,
                                          ),
                                        )
                                      }
                                      disabled={!edit}
                                      className={`w-full h-8 md:h-[36px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px] transition-colors ${
                                        edit
                                          ? 'bg-white focus:outline-none focus:ring-2 focus:ring-blue-500'
                                          : 'bg-gray-50 text-gray-600 cursor-not-allowed'
                                      }`}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                          {uploadedDocuments.filter((d) => !!d.document)
                            .length === 0 &&
                            edituserAttachment.length === 0 &&
                            userAttachment.length === 0 && (
                              <p className="text-[11px] md:text-[12px] text-[#9CA3AF] text-center py-3 md:py-4">
                                No documents uploaded yet.
                              </p>
                            )}
                          <div className="mt-4 md:mt-5">
                            <p className="text-[11px] md:text-[12px] font-[600] text-[#6B7280] mb-2">
                              Compliance (Notes & Attachment)
                            </p>
                            <textarea
                              value={
                                !edit ? complianceNotes : editcomplianceNotes
                              }
                              disabled={!edit}
                              onChange={(e) =>
                                edit && seteditComplianceNotes(e.target.value)
                              }
                              className={`w-full p-2 rounded-lg outline-none text-sm placeholder:text-[#707070] resize-none mb-3 ${
                                edit
                                  ? 'bg-white border border-gray-300'
                                  : 'bg-gray-100'
                              }`}
                              placeholder="Add compliance notes..."
                              rows={3}
                            />

                            {edit && (
                              <div className="mb-3 md:mb-4">
                                <label className="text-xs md:text-[13px] font-[600] text-[#2563EB] cursor-pointer flex items-center gap-2">
                                  ⬆ Upload Documents
                                  <input
                                    type="file"
                                    hidden
                                    ref={complianceFileInputRef}
                                    multiple
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={handleComplianceFileChange}
                                  />
                                </label>
                                <p className="text-[10px] md:text-[11px] text-[#9CA3AF] mt-1">
                                  Supported Format : JPG, PNG, PDF (Max 8MB)
                                </p>
                              </div>
                            )}

                            {/* Newly selected files this session — always shown, never hidden by a saved/pending toggle */}
                            {pendingComplianceFiles.length > 0 && (
                              <div className="w-full py-3 px-4 border border-dashed border-blue-400 rounded-lg bg-blue-50/30 flex flex-col gap-2 mt-1">
                                {pendingComplianceFiles.map((file, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center justify-between gap-2"
                                  >
                                    <div className="flex items-center gap-2 flex-1 min-w-0">
                                      <img
                                        src="./file-icon.jpeg"
                                        className="w-5 h-5 flex-shrink-0"
                                        alt="file"
                                        onError={(e) => {
                                          e.target.style.display = 'none';
                                        }}
                                      />
                                      <span className="text-xs text-gray-700 break-all">
                                        {file.name}
                                      </span>
                                    </div>
                                    <div className="flex items-center gap-3 flex-shrink-0">
                                      <button
                                        className="text-xs font-[600] text-[#2563EB] hover:underline cursor-pointer bg-transparent border-none p-0"
                                        onClick={() =>
                                          window.open(file.blobUrl, '_blank')
                                        }
                                      >
                                        View
                                      </button>
                                      {edit && (
                                        <button
                                          className="text-xs font-[600] text-red-500 hover:underline cursor-pointer bg-transparent border-none p-0"
                                          onClick={() =>
                                            handleDeletePendingComplianceFile(
                                              index,
                                            )
                                          }
                                        >
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {complianceAttachment.length > 0 && (
                              <div className="w-full py-3 px-4 border border-dashed border-blue-400 rounded-lg bg-blue-50/30 flex flex-col gap-2 mt-1">
                                {complianceAttachment.map((att, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center justify-between gap-2"
                                  >
                                    <div className="flex items-center gap-2 flex-1 min-w-0">
                                      <img
                                        src="./file-icon.jpeg"
                                        className="w-5 h-5 flex-shrink-0"
                                        alt="file"
                                        onError={(e) => {
                                          e.target.style.display = 'none';
                                        }}
                                      />
                                      <span className="text-xs text-gray-700 break-all">
                                        {typeof att === 'string'
                                          ? att.split('/').pop()
                                          : att?.name}
                                      </span>
                                    </div>
                                    <div className="flex items-center gap-3 flex-shrink-0">
                                      <button
                                        className="text-xs font-[600] text-[#2563EB] hover:underline cursor-pointer bg-transparent border-none p-0"
                                        onClick={() =>
                                          window.open(
                                            Constants.FILE_PATH_BASE_URL + att,
                                            '_blank',
                                          )
                                        }
                                      >
                                        View
                                      </button>
                                      {edit && (
                                        <button
                                          className="text-xs font-[600] text-red-500 hover:underline cursor-pointer bg-transparent border-none p-0"
                                          onClick={() => {
                                            setDeletedComplianceAttachments(
                                              (prev) => [...prev, att],
                                            );
                                            setcomplianceAttachment((prev) =>
                                              prev.filter(
                                                (_, i) => i !== index,
                                              ),
                                            );
                                          }}
                                        >
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          {!edit && (
                            <button
                              onClick={() => setEdit(true)}
                              className="w-full h-10 md:h-[46px] rounded-lg md:rounded-[8px] bg-[#D86B1F] text-white font-[600] text-sm md:text-base flex items-center justify-center gap-2"
                            >
                              Edit
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={2.5}
                                stroke="#FFFFFF"
                                className="w-4 h-4"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                                />
                              </svg>
                            </button>
                          )}

                          {edit && (
                            <div>
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mt-2">
                                <div>
                                  <label className="text-[11px] md:text-[12px] text-[#757E8C] block mb-1 md:mb-2">
                                    Field Name
                                  </label>
                                  <select
                                    value={editfieldSelectedName || ''}
                                    onChange={(e) =>
                                      seteditFieldSelectedName(e.target.value)
                                    }
                                    className="w-full h-9 md:h-[42px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px]"
                                  >
                                    <option value="">-Name-</option>
                                    {editfieldName.map((item) => (
                                      <option key={item.id} value={item.value}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div>
                                  <label className="text-[11px] md:text-[12px] text-[#757E8C] block mb-1 md:mb-2">
                                    Field Value
                                  </label>
                                  <select
                                    value={editfieldSelectedValue || ''}
                                    onChange={(e) =>
                                      seteditFieldSelectedValue(e.target.value)
                                    }
                                    className="w-full h-9 md:h-[42px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px]"
                                  >
                                    <option value="">-Value-</option>
                                    {editfieldValue.map((item) => (
                                      <option key={item.id} value={item.value}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div>
                                  <label className="text-[11px] md:text-[12px] text-[#757E8C] block mb-1 md:mb-2">
                                    Flag
                                  </label>
                                  <select
                                    value={editSelectedflag || ''}
                                    onChange={(e) =>
                                      seteditSelectedFlag(e.target.value)
                                    }
                                    className="w-full h-9 md:h-[42px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px]"
                                  >
                                    <option value="">-Flag-</option>
                                    {editflag?.map((flag) => (
                                      <option key={flag} value={flag}>
                                        {flag}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div>
                                  <label className="text-[11px] md:text-[12px] text-[#6B7280] block mb-1 md:mb-2">
                                    Requested Documents
                                  </label>
                                  <select
                                    multiple
                                    size={2}
                                    value={edittypeOfDocuments}
                                    onChange={(e) => {
                                      const values = [
                                        ...e.target.selectedOptions,
                                      ].map((opt) => opt.value);
                                      setedittypeOfDocuments(values);
                                    }}
                                    className="w-full h-9 md:h-[42px] border border-[#E5E7EB] rounded-[8px] px-2 md:px-3 text-[12px] md:text-[13px]"
                                  >
                                    {transactionUserType === 'individual'
                                      ? individual.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.document}
                                          </option>
                                        ))
                                      : business.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.document}
                                          </option>
                                        ))}
                                  </select>
                                </div>
                              </div>

                              <div className="flex flex-col sm:flex-row gap-2 md:gap-3 mt-4 md:mt-6">
                                <button
                                  onClick={() => {
                                    setEdit(false);
                                    setEditingDocIndex(null);
                                    setedituserAttachment([]);
                                    setPendingComplianceFiles([]);
                                  }}
                                  className="flex-1 h-11 flex items-center justify-center md:h-[46px] rounded-lg md:rounded-[8px] bg-[#E5E7EB] text-[#6B7280] font-[600] text-sm md:text-base"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={() => {
                                    setLoading(true);
                                    saveData();
                                  }}
                                  className="flex-1 h-11 flex items-center justify-center md:h-[46px] rounded-lg md:rounded-[8px] bg-[#D86B1F] text-white font-[600] text-sm md:text-base"
                                >
                                  {loading ? 'Saving' : 'Save'}
                                </button>
                              </div>
                            </div>
                          )}
                          {adminRequestedAttachments?.length > 0 &&
                            !loading && (
                              <div className="mt-3 md:mt-4 bg-[#FCFCFC] border border-[#E5E7EB] rounded-lg md:rounded-[12px] p-3 md:p-4">
                                <h3 className="text-sm md:text-[14px] font-[700] text-[#1F2A44] mb-3 md:mb-4">
                                  Admin Requested Documents
                                </h3>
                                <div className="space-y-2 md:space-y-3">
                                  {adminRequestedAttachments.map(
                                    (document, index) => (
                                      <div
                                        key={index}
                                        className="border border-[#E5E7EB] rounded-lg md:rounded-[10px] p-2 md:p-3 bg-[#FCFCFC]"
                                      >
                                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
                                          <div className="flex-1 min-w-0">
                                            <p className="text-xs md:text-[13px] font-[600] text-[#1F2A44] truncate">
                                              {document.document}
                                            </p>
                                            <p className="text-[10px] md:text-[11px] text-[#9CA3AF]">
                                              Requested Document #{index + 1}
                                            </p>
                                          </div>
                                          {document.pivot?.document ? (
                                            <a
                                              rel="noopener noreferrer"
                                              target="_blank"
                                              href={
                                                Constants.FILE_PATH_BASE_URL +
                                                document.pivot.document
                                              }
                                              className="text-[#2563EB] text-[11px] md:text-[12px] font-[600] whitespace-nowrap"
                                            >
                                              View
                                            </a>
                                          ) : (
                                            <span className="text-[11px] md:text-[12px] text-[#9CA3AF] whitespace-nowrap">
                                              Not Uploaded
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}

                          {paymentSubmitted && (
                            <div className="mt-3 md:mt-4 bg-white border border-[#E5E7EB] rounded-lg md:rounded-[12px] p-3 md:p-4">
                              <h3 className="text-sm md:text-[14px] font-[700] text-[#1F2A44] mb-3 md:mb-4">
                                Payment Status
                              </h3>
                              <div className="bg-[#FCFCFC] border border-[#E5E7EB] rounded-lg md:rounded-[10px] p-3 md:p-4">
                                <div className="flex justify-between py-1 md:py-2">
                                  <span className="text-[12px] md:text-[13px] text-[#6B7280]">
                                    Transaction
                                  </span>
                                  <span className="text-[12px] md:text-[13px] font-[600] text-[#1F2A44]">
                                    {paymentSubmitted}
                                  </span>
                                </div>
                                <div className="flex justify-between py-1 md:py-2">
                                  <span className="text-[12px] md:text-[13px] text-[#6B7280]">
                                    Payment ID
                                  </span>
                                  <span className="text-[12px] md:text-[13px] font-[600] text-[#1F2A44]">
                                    {paymentId}
                                  </span>
                                </div>
                                <div className="flex justify-between py-1 md:py-2">
                                  <span className="text-[12px] md:text-[13px] text-[#6B7280]">
                                    Status
                                  </span>
                                  <span
                                    className={`text-[12px] md:text-[13px] font-[600] ${
                                      paymentStatus?.toLowerCase() ===
                                      'completed'
                                        ? 'text-green-600'
                                        : paymentStatus?.toLowerCase() ===
                                            'failed'
                                          ? 'text-red-600'
                                          : 'text-[#D86B1F]'
                                    }`}
                                  >
                                    {paymentStatus}
                                  </span>
                                </div>
                                {!paymentSubmitted && !loading && (
                                  <div className="hidden">
                                    <button
                                      onClick={submitTopayOut}
                                      className="bg-[#0B214E] text-white px-4 py-2 rounded-lg"
                                    >
                                      {payoutButton}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default DebitTransactions;